/* ─────────────────────────────────────────────
   OFFERS CONFIGURATION - /ponude, /en/offers, /de/angebote

   The page carries THREE offers, in descending order of importance:
     1. OFFER        - the September group of the basic makeup course
     2. ADVANCED_OFFER - the one-on-one advanced course
     3. HAIR_OFFER   - "Posle mora", the after-summer colour promotion

   Everything volatile about the course offers already lives in
   src/config/educations.mjs (start date, seats, price, deposit) and is
   imported here rather than copied - one date, one source.

   What is genuinely offer-only lives below: the early-bird seat count, the
   reach we promise the advanced students, the hair offer's thresholds, and
   the windows the Offer JSON-LD blocks are valid for.

   NEXT GROUP - edit in this order:
     1. src/config/educations.mjs → startDate, startDateLabel,
        startDateInline, maxAttendees, priceEur, priceRsdApprox, depositEur
     2. this file → validFrom, HAIR_OFFER.validThrough, and the popup's
        sessionStorage key below (a new key means the popup shows again for
        everyone)

   .mjs on purpose: scripts/prerender.mjs imports it with plain Node, no
   bundler. Keep it free of JSX and React.
   ───────────────────────────────────────────── */

import { BASIC_COURSE } from './educations.mjs';

export const OFFER = {
  /** How many of the seats get the free gift (nails OR lashes, her choice).
      The gift itself is never quoted with a value, on the page or in the
      schema: it reads as a gift, not as a discount. */
  earlyBirdSeats: 3,

  /** Offer.validFrom - the day the offer went public. */
  validFrom: '2026-08-26',
  /** Offer.validThrough - the offer dies when the group starts. Derived, so
      moving the start date in educations.mjs moves this with it. */
  get validThrough() {
    return BASIC_COURSE.startDate;
  },

  /**
   * sessionStorage key for the popup. Bump it for a new group so returning
   * visitors see the new offer once instead of never.
   */
  popupKey: 'vb_offer_2026_09',
  /** Popup shows after this many ms, or at the scroll ratio below - whichever
      comes first. */
  popupDelayMs: 3000,
  popupScrollRatio: 0.25,
};

/* ── Card 2 - advanced course, one on one ──
   No date of its own, and the price and deposit come from ADVANCED_COURSE in
   educations.mjs, so the only volatile number here is the Instagram reach we
   promise. The early-bird gift is the same one the basic course gives: nails
   or lashes, her choice. */
export const ADVANCED_OFFER = {
  /** Followers on the Vision Beauty Instagram, rounded down to the hundred. */
  instagramFollowers: 6800,
  earlyBirdSeats: 3,
};

/* ── Card 3 - "Posle mora", the hair offer ──
   Runs on its own calendar, not the course's, so it carries its own
   validThrough. Ends and the card comes off the page. */
export const HAIR_OFFER = {
  /** Minimum colour-service spend that unlocks the offer, in RSD. */
  minSpendRsd: 8000,
  /** Free tone-correction window, in days. */
  toneGuaranteeDays: 14,
  /** Offer.validFrom / validThrough for the hair Offer block. */
  validFrom: '2026-08-26',
  validThrough: '2026-09-30',
  /** Human-readable end date shown on the page, per language. */
  validThroughLabel: {
    sr: '30. septembra',
    en: '30 September',
    de: '30. September',
  },
};

/** Seats, start date and price, read straight off the course config. */
export const OFFER_COURSE = BASIC_COURSE;
